/** Open and Close Functionality for v8 Modal */
const v8NonceRequests = new WeakMap();

function v8GetModalContainer(trigger) {
  if (trigger && trigger.dataset && trigger.dataset.v8ModalTarget) {
    const targetModal = document.querySelector(trigger.dataset.v8ModalTarget);

    if (targetModal) {
      return targetModal;
    }
  }

  if (trigger && typeof trigger.closest === 'function') {
    const parentModal = trigger.closest('.v8Modal');

    if (parentModal) {
      return parentModal;
    }
  }

  return document.querySelector('.v8Modal');
}

function v8SetTriggerBusy(trigger, isBusy) {
  if (!trigger || typeof trigger.setAttribute !== 'function') {
    return;
  }

  if (isBusy) {
    trigger.setAttribute('aria-busy', 'true');
    trigger.setAttribute('aria-disabled', 'true');
  } else {
    trigger.removeAttribute('aria-busy');
    trigger.removeAttribute('aria-disabled');
  }
}

function v8ClearNonceErrors() {
  const errors = document.querySelectorAll('.v8Modal__nonce-error');

  for (const error of errors) {
    error.remove();
  }
}

function v8ShowNonceError(trigger) {
  v8ClearNonceErrors();

  const error = document.createElement('div');
  error.classList.add('v8Modal__nonce-error');
  error.setAttribute('role', 'alert');
  error.setAttribute('tabindex', '-1');
  error.textContent =
    window.v8ModalSettings && window.v8ModalSettings.errorMessage
      ? window.v8ModalSettings.errorMessage
      : 'We could not open the scheduling form. Please try again.';

  if (trigger && typeof trigger.insertAdjacentElement === 'function') {
    trigger.insertAdjacentElement('afterend', error);
  } else {
    document.body.appendChild(error);
  }

  error.focus();
}

function v8RequestNonce(modal) {
  return new Promise((resolve, reject) => {
    const settings = window.v8ModalSettings;

    if (!settings || !settings.ajaxUrl || !settings.nonceAction) {
      reject(new Error('V8 nonce refresh is not configured.'));
      return;
    }

    const request = new XMLHttpRequest();
    const requestBody =
      `action=${encodeURIComponent(settings.nonceAction)}` +
      `&_=${encodeURIComponent(Date.now())}`;

    request.open('POST', settings.ajaxUrl, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    request.setRequestHeader('Cache-Control', 'no-cache');
    request.setRequestHeader('Pragma', 'no-cache');
    request.timeout = 10000;

    request.onload = function () {
      let response;

      try {
        response = JSON.parse(request.responseText);
      } catch (error) {
        reject(new Error('V8 nonce refresh returned an invalid response.'));
        return;
      }

      if (
        request.status < 200 ||
        request.status >= 300 ||
        !response.success ||
        !response.data ||
        typeof response.data.nonce !== 'string' ||
        !response.data.nonce
      ) {
        reject(new Error('V8 nonce refresh failed.'));
        return;
      }

      const nonceFields = modal.querySelectorAll('input[name="_v8nonce"]');

      if (!nonceFields.length) {
        reject(new Error('No V8 nonce fields were found.'));
        return;
      }

      for (const nonceField of nonceFields) {
        nonceField.value = response.data.nonce;
      }

      resolve(response.data.nonce);
    };

    request.onerror = function () {
      reject(new Error('V8 nonce refresh request failed.'));
    };

    request.ontimeout = function () {
      reject(new Error('V8 nonce refresh request timed out.'));
    };

    request.send(requestBody);
  });
}

function v8ModalOpen(trigger) {
  const modal = v8GetModalContainer(trigger);

  if (!modal || modal.classList.contains('active')) {
    return Promise.resolve(false);
  }

  if (v8NonceRequests.has(modal)) {
    return v8NonceRequests.get(modal);
  }

  v8SetTriggerBusy(trigger, true);
  v8ClearNonceErrors();

  const nonceRequest = v8RequestNonce(modal).then(
    function () {
      v8NonceRequests.delete(modal);
      v8SetTriggerBusy(trigger, false);
      modal.classList.remove('out');
      modal.classList.add('active');

      // Have to focus on the 1st step for accessibility purposes
      const stepOne = modal.querySelector('.v8Form__steps > span');

      if (stepOne) {
        stepOne.focus();
      }

      return true;
    },
    function (error) {
      v8NonceRequests.delete(modal);
      v8SetTriggerBusy(trigger, false);
      v8ShowNonceError(trigger);

      if (window.console && typeof window.console.error === 'function') {
        window.console.error(error);
      }

      return false;
    }
  );

  v8NonceRequests.set(modal, nonceRequest);
  return nonceRequest;
}

function v8ModalClose(closeButton) {
  const modal = v8GetModalContainer(closeButton);

  if (modal && modal.classList.contains('active')) {
    modal.classList.add('out');
    modal.classList.remove('active');
  }
}

function autoPop() {
  const autoModalTrigger = document.querySelector('.v8-modal-auto');

  if (autoModalTrigger) {
    autoModalTrigger.click();
  }
}

window.addEventListener('load', () => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get('autoPop') === 'true') {
    autoPop();
  }
});
